import { ApplicationConfiguration } from '@/types/api/app-configuration'
import { computed, reactive } from 'vue'

const state = reactive({
  configuration: null as null | ApplicationConfiguration
})

async function storeConfiguration(configuration: ApplicationConfiguration) {
  state.configuration = configuration
}

function setCustomColorTheme() {
  const root = document.documentElement
  if(state.configuration?.theme?.primaryColor) {
    root.style.setProperty('--color-primary-hsl', `${state.configuration?.theme.primaryColor.hue}, ${state.configuration?.theme.primaryColor.saturation * 100}% `)
  }
  if(state.configuration?.theme?.secondaryColor) {
    root.style.setProperty('--color-secondary-hsl', `${state.configuration?.theme.secondaryColor.hue}, ${state.configuration?.theme.secondaryColor.saturation * 100}% `)
  }
}

export const appConfiguration = computed(() => state.configuration)

export { storeConfiguration, setCustomColorTheme }
